import { createApi } from "@/api/ApiFactory";
import { config } from "@/config/config";

const CrmApi = createApi(config.CRM_API_URL);

export default CrmApi;
